import { useState } from "react";
import { disconnectMp, mpPlanOk, startMpConnect } from "../../mercadoPago.js";
import { notify, notifyError } from "./useBusiness";
import { takesOrders } from "../../menu.js";
import { MP_PRO_ONLY } from "../../plans.js";
import Dialog from "./Dialog";

// Cobrar el carrito con Mercado Pago: el dueño conecta SU cuenta y los clientes pagan
// el pedido online; la plata va directo a esa cuenta. Los tokens los guarda n8n.
const MercadoPagoCard = ({ business, onChanged }) => {

    const [busy, setBusy] = useState(false);
    const [confirming, setConfirming] = useState(false);
    const planOk = mpPlanOk(business);
    const connected = business.mpConectado === true;
    const ordersOn = takesOrders(business);

    const connect = () => {
        setBusy(true);
        startMpConnect();
    }

    const disconnect = async () => {
        setBusy(true);
        try {
            await disconnectMp();
            setConfirming(false);
            notify("Listo, desconectaste Mercado Pago. Los pedidos se siguen mandando por WhatsApp.");
            await onChanged();
        } catch (error) {
            console.error(error);
            notifyError("No pudimos desconectar Mercado Pago. Probá de nuevo en unos minutos.");
        }
        setBusy(false);
    }

  return (
    <section className="lp-panel-card lp-panel-stack">
        <div className="lp-panel-card-head">
            <h2>Cobrar con Mercado Pago</h2>
            {!planOk ? <span className="lp-panel-badge">Pro</span> :
                connected && <span className="lp-panel-badge lp-panel-badge-ok">Conectado</span>}
        </div>
        <p className="lp-panel-muted">
            Tus clientes pagan el pedido online desde el carrito y la plata va directo a tu cuenta de Mercado Pago.
            En Pedidos vas a ver cuáles están pagados.
        </p>

        {!planOk ?
            <a className="lp-text-link lp-panel-left" href="#cuenta">{MP_PRO_ONLY ? "Pasate a Pro para cobrar con Mercado Pago" : "Mejorá tu plan"}</a> :
        connected ?
            <>
                <dl className="lp-panel-rows">
                    <div>
                        <dt>Cuenta</dt>
                        <dd>{business.mpCuenta || "Conectada"}</dd>
                    </div>
                </dl>
                {!ordersOn &&
                    <p className="lp-panel-notice">Para que tus clientes puedan pagar, activá los pedidos por WhatsApp.</p>
                }
                <button type="button" className="lp-btn lp-btn-secondary lp-panel-btn-sm lp-panel-left" disabled={busy} onClick={() => setConfirming(true)}>Desconectar</button>
            </> :
            <>
                <button type="button" className="lp-btn lp-btn-primary lp-panel-btn-sm lp-panel-left lp-panel-mp-btn" disabled={busy} onClick={connect}>
                    {busy ? "Abriendo Mercado Pago…" : "Conectar Mercado Pago"}
                </button>
                <p className="lp-panel-muted">Te lleva a Mercado Pago para que autorices a MiQRapp a cobrar a tu nombre. Mercado Pago cobra su comisión de siempre por cada venta.</p>
            </>
        }

        <Dialog open={confirming} title="¿Desconectar Mercado Pago?" onClose={() => !busy && setConfirming(false)}>
            <div className="lp-panel-stack">
                <p>Tus clientes ya no van a poder pagar online. Los pedidos se siguen mandando por WhatsApp y podés volver a conectarla cuando quieras.</p>
                <div className="lp-panel-actions">
                    <button type="button" className="lp-btn lp-btn-secondary" disabled={busy} onClick={() => setConfirming(false)}>Cancelar</button>
                    <button type="button" className="lp-btn lp-btn-primary" disabled={busy} onClick={disconnect}>{busy ? "Desconectando…" : "Desconectar"}</button>
                </div>
            </div>
        </Dialog>
    </section>
  )
}

export default MercadoPagoCard
